var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIconColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CBD5D7F3-0566-4172-BA68-2D9118B1A751") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-designs-current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TP_DIY-TBA-Uncon-CurrentSearch-3-Modal-1",
    transform: "translate(-643.000000, -358.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Download-Small",
    transform: "translate(640.000000, 356.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/DownloadSmall",
    transform: "translate(3.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,16 L2,18 L16,18 L16,16 L18,16 L18,20 L0,20 L0,16 L2,16 Z M10,0 L10,10.584 L14.2928932,6.29289322 L15.7071068,7.70710678 L9,14.4142136 L2.29289322,7.70710678 L3.70710678,6.29289322 L8,10.586 L8,0 L10,0 Z",
    id: "Download"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconColor);
export default __webpack_public_path__ + "static/media/DownloadIconColor.07ba94ed.svg";
export { ForwardRef as ReactComponent };